import { render, staticRenderFns } from "./EnrollmentPricingPlans.vue?vue&type=template&id=3e8b2af4&scoped=true"
import script from "./EnrollmentPricingPlans.vue?vue&type=script&lang=js"
export * from "./EnrollmentPricingPlans.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentPricingPlans.vue?vue&type=style&index=0&id=3e8b2af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8b2af4",
  null
  
)

export default component.exports